/* eslint-disable @next/next/no-img-element */
import GradientContainer from "../gradient/gradient-container"
import Icon from "@mdi/react"
import { mdiApplicationSettings, mdiCellphone } from "@mdi/js";

const Setup = () => {
  return (
    <div className="bg-background-primary-dark-dark xxxs:pb-10 md:pb-24 overflow-hidden">
      <div className="flex flex-col items-center pt-24">
        <span className="text-white text-center">
          <p className="md:text-body-xl xxxs:text-body-md">
            Work your way.
          </p>
          <h3 className="mobile-h3 md:h2">Easy to set up and use.</h3>
        </span>
        <GradientContainer overrideClassName="w-36 h-2 mt-3" />
      </div>
      <div className="mt-6 md:mt-24 px-5 flex flex-col-reverse space-y-5 md:flex-row 
      md:items-center md:px-0 md:space-y-0 2xl:px-40 4xl:px-48">
        <div className="md:basis-1/2 flex justify-center
        md:relative md:-left-12 lg:-left-16 xl:-left-24 3xl:!static">
          <div>
            <img src="images/platform/integrations.png" alt="" />
          </div>
        </div>
        <div className="space-y-3 pb-6 md:pb-0 md:basis-1/2 md:px-8 xl:px-24 md:space-y-5">
          <div>
            <GradientContainer overrideClassName="p-3 mb-2 w-12 rounded-full shadow-outer-secondary">
              <Icon size={1} path={mdiApplicationSettings} className="text-white" />
            </GradientContainer>
            <h4 className="text-white mobile-h4 md:h5 lg:h4">
              Works with what you already have.
            </h4>
          </div>
          <div className="xxxs:text-body-lg lg:text-body-xl text-white">
            <p>
              SimpleWaste integrates with QuickBooks, Office 365, Dropbox, Slack, Monday, Asana, and more seamlessly.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-6 md:mt-24 px-5 flex flex-col-reverse space-y-5 md:flex-row-reverse 
      md:items-center md:px-0 md:space-y-0 2xl:px-40 4xl:px-48">
        <div className="md:basis-1/2 flex justify-center
        md:relative md:-right-12 lg:-right-16 xl:-right-24 3xl:!static">
          <div>
            <img src="images/platform/location.png" alt="" />
          </div>
        </div>
        <div className="space-y-3 pb-6 md:pb-0 md:basis-1/2 md:px-8 xl:px-24 md:space-y-5">
          <div>
            <GradientContainer overrideClassName="p-3 mb-2 w-12 rounded-full shadow-outer-secondary">
              <Icon size={1} path={mdiApplicationSettings} className="text-white" />
            </GradientContainer>
            <h4 className="text-white mobile-h4 md:h5 lg:h4">
              Keeps you in control on the go.
            </h4>
          </div>
          <div className="xxxs:text-body-lg lg:text-body-xl text-white">
            <p>
              Anywhere, anytime. 24/7 access, even on the go.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Setup